import React from "react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const retailData = {
  badge: "Commerce AI",
  title: "Retail & Commerce AI",
  industry: "Retail",
  tagline: "Turn every browser into a buyer with AI shopping assistants and intelligent commerce automation.",
  image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=85&w=1200&h=800",
  cta: "Explore Commerce Platform",
  stats: [
    { number: "35%", label: "Higher Conversion Rate" },
    { number: "50%", label: "Cart Recovery Rate" },
    { number: "4x", label: "Customer Engagement" },
    { number: "30%", label: "Increase in AOV" },
  ],
  problems: [
    {
      title: "Customer Support Volume",
      desc: "High support ticket volumes overwhelm teams with repetitive order, shipping, and product queries.",
    },
    {
      title: "Product Discovery Friction",
      desc: "Customers can't find what they're looking for, leading to frustration and abandoned sessions.",
    },
    {
      title: "Cart Abandonment Rates",
      desc: "70%+ of carts are abandoned — recovery requires instant, personalized re-engagement that scales.",
    },
    {
      title: "Low Customer Engagement",
      desc: "Generic marketing messages fail to resonate, leading to poor email open rates and retention.",
    },
  ],
  solutions: [
    {
      title: "AI Shopping Assistants",
      desc: "Conversational AI that helps customers find products, compare options, and complete purchases.",
    },
    {
      title: "WhatsApp Commerce Agents",
      desc: "Full shopping experience on WhatsApp — browse, order, track, and support all in one conversation.",
    },
    {
      title: "Recommendation Engines",
      desc: "AI-powered personalization that suggests the right products at the right time to maximize AOV.",
    },
    {
      title: "AI Customer Retention Systems",
      desc: "Automated win-back campaigns, loyalty programs, and personalized re-engagement workflows.",
    },
  ],
  outcome:
    "Increase conversion rates by 35%, recover 50% of abandoned carts, and grow average order value by 30% through personalized AI-driven shopping experiences. Build a loyal customer base that comes back again and again.",
};

const RetailPage = () => <IndustryPageTemplate data={retailData} />;

export default RetailPage;
